import { Appointment, EAppointmentState } from "../appointment.entity";
import { User } from "../../user.entity";
import { DoctorAvailability } from "../../doctor-disponiblity.entity/doctor-availability";
import { Doctor } from "../../user.entity/doctor.entity";

export enum EPatientAppointmentStatus {
  AT_HOME = 'AT_HOME',
  AT_CABINET = 'AT_CABINET',
  WITH_DOCTOR = 'WITH_DOCTOR',
  CABINET_OUT = 'CABINET_OUT'
}
export class DoctorAppointment extends Appointment {
    patient: User;
    doctorReminding: boolean = false;
    doctorRemindingTime: number = 0;
doctor?:Doctor;
assistantId?:string | null;
assistantLastName:string;
assistantFirstName:string;
assistanceColorCode:string;
patientImageProfile:string;
pec:string;
totalAppOnhold?:number;
patientAppointmentStatus: EPatientAppointmentStatus = EPatientAppointmentStatus.AT_HOME;
    constructor(other?: Partial<DoctorAppointment>) {
        super(other)
        this.patient = other?.patient || new User();
        this.doctorReminding = other?.doctorReminding || false;
        this.doctorRemindingTime = other?.doctorRemindingTime || 0;
        this.doctor=other?.doctor || new Doctor();
        this.assistantLastName=other?.assistantLastName || '';
        this.assistantFirstName=other?.assistantFirstName || '';
        this.assistantId=other?.assistantId || '';
        this.assistanceColorCode=other?.assistanceColorCode || '';
        this.patientImageProfile=other?.patientImageProfile || '';
        this.pec=other?.pec || '';
        this.totalAppOnhold=other?.totalAppOnhold || 0;
        this.patientAppointmentStatus=other?.patientAppointmentStatus || EPatientAppointmentStatus.AT_HOME;

    }

    public static fromResponse(res: any): DoctorAppointment {
        return new DoctorAppointment({
            patient: res.patient !== null ? User.fromResponse(res.patient) : new User(),
            doctorReminding: res.doctorReminding,
            doctorRemindingTime: res.doctorRemindingTime,
            assistantId:res.assistantId,
            assistantLastName:res.assistantLastName,
            assistantFirstName:res.assistantFirstName,
            assistanceColorCode:res.assistanceColorCode,
patientImageProfile:res.patientImageProfile,
            doctor:res.doctor,
            pec:res.pec,
            totalAppOnhold:res.totalAppOnhold,
            patientAppointmentStatus:res.patientAppointmentStatus,
            ...Appointment.fromResponse(res),
        });
    }

    get doctorAvailability() {
        return new DoctorAvailability({
            date: this.date,
            startTime: this.startTime,
            location: this.location,
            private: false,
            duration: this.duration
        })
    }

    get requestPayload() {

        return {
            
            date: this.date.getTime(),
            startTime: this.startTime,
            duration: this.duration,
            location: this.location,
            isEmergency: this.isEmergency,
            status: EAppointmentState.PENDING,
            motif: this.motif,
            doctorReminding: this.doctorReminding,
            doctorRemindingTime: this.doctorRemindingTime,
            colorCode:this.colorCode,
            assistantId:this.assistantId?this.assistantId:null,
        }
    }

    get reminderDurations(): { days: number, minutes: number, hours: number } {
        const days = Math.floor(this.doctorRemindingTime / (24 * 60));
        const hours = Math.floor((this.doctorRemindingTime % (24 * 60)) / 60);
        const minutes = this.doctorRemindingTime % 60;
        return { days, hours, minutes };
    }

}
